import {fromJS} from 'immutable';

import QuestionTypeStore from 'components/QuestionTypes/QuestionType.store';
import {GuessModel} from 'resources/Guess/Guess.model';

import freeEntryQuestionActions from './FreeEntryQuestion.actions';

export default class FreeEntryQuestionStore extends QuestionTypeStore {
  constructor(name, questionId, question) {
    super(name);
    this.initialData = fromJS({
      questionId,
      openTopFive: [],
      inputValues: {},
      shouldShowExplanation: false
    });

    this.setInitialData(this.initialData);
    this.writeData('__question', question);
    this.handleTargeted(freeEntryQuestionActions.UPDATE_INPUT, this._updateInput);
  }

  _updateInput({inputId, value}) {
    this.writeData((store) => store.setIn(['inputValues', inputId], value));
  }

  _loadGuess(guess) {
    super._loadGuess(guess);

    this.writeData('inputValues', guess.get('content'));
  }

  _clearGuess() {
    super._clearGuess();

    this.writeData('inputValues', this.initialData.get('inputValues'));
  }

  buildCorrectGuess(question) {
    return new GuessModel({
      content: question.getValidResponse().map((val) => val.first()),
      correct: true,
      rubric: question.getMeta().getQuestionRubric(),
      solutionText: question.getSolutionText(),
      pointsPossible: question.getPoints(),
      pointsEarned: question.getPoints(),
      question
    });
  }

  buildGuessContent() {
    const guessContent = this.readData('inputValues').toJS();
    const trimmedGuessContent = Object.keys(guessContent).reduce((acc, key) => {
      acc[key] = guessContent[key].trim();
      return acc;
    }, {});
    return trimmedGuessContent;
  }

  getValueForId(inputId) {
    return this.readData(['inputValues', inputId]);
  }
}
